import { useEffect, useState } from "react";
import {
  onSnapshot,
  where,
  QueryConstraint,
} from "firebase/firestore";
import { orgQuery } from "@/lib/org";
import type { Student } from "@/types";

export interface StudentFilter {
  gu?: string;
  dong?: string;
  school?: string;
  brand?: string;
  courier?: boolean;
  status?: string;
}

export function useStudents(filter: StudentFilter = {}): {
  students: Student[];
  loading: boolean;
} {
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cons: QueryConstraint[] = [];
    if (filter.gu) cons.push(where("gu", "==", filter.gu));
    if (filter.dong) cons.push(where("dong", "==", filter.dong));
    if (filter.school) cons.push(where("school", "==", filter.school));
    if (filter.brand) cons.push(where("brand", "==", filter.brand));
    if (filter.courier !== undefined) cons.push(where("courierFlag", "==", filter.courier));
    if (filter.status) cons.push(where("status", "==", filter.status));

    const q = orgQuery("students", ...cons);
    const unsub = onSnapshot(
      q,
      (snap) => {
        setStudents(snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })));
        setLoading(false);
      },
      (err) => {
        console.error(err);
        setLoading(false);
      },
    );
    return () => unsub();
  }, [filter.gu, filter.dong, filter.school, filter.brand, filter.courier, filter.status]);

  return { students, loading };
}
